export const filters_store = {
    protocol_id: {
        type: 'list',
        list: [],
        value: undefined,
        placeholder: '',
        item_text: "name",
        item_value: "id",
    },
    patient_id: {
        type: 'text',
        replace: "%VALUE%",
        placeholder: '',
        style: 'max-width:60px'
    },
    crf: {
        type: 'list',
        value: undefined,
        list: [{
            name: "Yes",
            value: 1
        }, {
            name: "No",
            value: 0
        }],
        placeholder: '',
        item_text: "name",
        item_value: "value",
        style: 'max-width:100px'
    },
    status: {
        type: 'list',
        value: undefined,
        list: ["Open", "Close", "Warning", "Query", "Canceled"],
        placeholder: '',
        style: 'max-width:100px'
    },
    'protocol.sponsor_id': {
        value: undefined
    },
}